export const sidebarPath = {
  dashboard: '',
  devices: 'devices',
  nodes: 'nodes',
  real_time_dashboard: 'real-time-monitoring-dashboard',
  samples: 'samples',
  segs: 'segs',
};
